import React, { useState } from 'react';
import { Box, Typography, TableBody, TableCell, TableHead, TableRow, Tooltip, Button, IconButton } from '@mui/material';
import { Edit, FilterList } from '@mui/icons-material';
import StickyTableContainer from './StickyTableContainer';
import JoiningDetailsModal from '../models/JoiningDetailsModal';
import CheckboxIconMenu from './CheckboxIconMenu';

const pendingOptions = ['Payment Pending', 'Aadhar Pending', 'Offer Letter Pending', 'Monthly CTC Pending'];

const PendingJoiningDetails = ({ pendingCandidates }) => {
    const [joiningDetailsModalVisible, setJoiningDetailsModalVisible] = useState(false);
    const [selectedPendingDetailsCandidate, setSelectedPendingDetailsCandidate] = useState(null);
    const [selectedPendingItems, setSelectedPendingItems] = useState([]);

    const FILTER_RULES = {
        'Payment Pending': (item) => item.paymentAmount == null,
        'Aadhar Pending': (item) => item.aadharCardDocId == null,
        'Offer Letter Pending': (item) => item.offerLetterDocId == null,
        'Monthly CTC Pending': (item) => item.monthlyCTC == null
    };

    const filteredPendingCandidates = pendingCandidates.filter(item => {
        if (selectedPendingItems.length === 0) return true;
        return selectedPendingItems.every(filter => FILTER_RULES[filter]?.(item))
    });

    const handlePendingItemsChange = (data) => {
        setSelectedPendingItems(data);
    }

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}
            >
                <Typography variant='h6' sx={{ fontWeight: 'bold', color: '#3d3d3d', padding: '8px 0', marginLeft: '8px' }}>Pending Joining Details ({filteredPendingCandidates?.length})</Typography>
                <CheckboxIconMenu enableBadge options={pendingOptions} onChange={handlePendingItemsChange} style={{ marginRight: '8px' }} />
            </Box>
            <StickyTableContainer height={250} containerSx={{ paddingLeft: '4px', paddingRight: '4px' }}>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ padding: '4px', fontWeight: 'bold' }}>Candidate</TableCell>
                        <TableCell style={{ padding: '4px', fontWeight: 'bold' }}>Job Title</TableCell>
                        <TableCell style={{ padding: '4px', fontWeight: 'bold' }}>Employer</TableCell>
                        <TableCell style={{ padding: '4px' }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredPendingCandidates && filteredPendingCandidates.map((candidate) => (
                        <TableRow key={candidate.candidateId}>
                            <TableCell style={{ cursor: 'pointer', padding: '4px' }}>{candidate.candidateName}</TableCell>
                            <TableCell style={{ padding: '4px' }}>{candidate.jobTitle}</TableCell>
                            <TableCell style={{ padding: '4px' }}>{candidate.employerBrandName}</TableCell>
                            <TableCell style={{ padding: '4px' }}>
                                <Tooltip title="Update Details">
                                    <Button size='small' style={{ minWidth: '32px' }} color="primary" onClick={(e) => {
                                        setSelectedPendingDetailsCandidate(candidate);
                                        setJoiningDetailsModalVisible(true);
                                    }}>
                                        <Edit />
                                    </Button>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </StickyTableContainer>

            {joiningDetailsModalVisible &&
                <JoiningDetailsModal
                    open={true}
                    onClose={() => {
                        setJoiningDetailsModalVisible(false);
                    }}
                    jobPostId={selectedPendingDetailsCandidate.jobPostId}
                    jobTitle={selectedPendingDetailsCandidate.jobTitle}
                    candidate={selectedPendingDetailsCandidate}
                />
            }

        </Box>
    )
}

export default PendingJoiningDetails;